import React, { createContext, useContext } from "react";
const GatsbyMDXScopeContext = /*#__PURE__*/createContext({});
export const useMDXScope = scope => {
  const contextScope = useContext(GatsbyMDXScopeContext);
  return scope || contextScope;
};

if (typeof useMDXScope !== 'undefined' && useMDXScope && useMDXScope === Object(useMDXScope) && Object.isExtensible(useMDXScope) && !useMDXScope.hasOwnProperty('__filemeta')) {
  Object.defineProperty(useMDXScope, '__filemeta', {
    configurable: true,
    value: {
      name: "useMDXScope",
      filename: "../../node_modules/gatsby-plugin-mdx/context.js"
    }
  });
}

export const MDXScopeProvider = ({
  __mdxScope,
  children
}) => /*#__PURE__*/React.createElement(GatsbyMDXScopeContext.Provider, {
  value: __mdxScope
}, children);

if (typeof MDXScopeProvider !== 'undefined' && MDXScopeProvider && MDXScopeProvider === Object(MDXScopeProvider) && Object.isExtensible(MDXScopeProvider) && !MDXScopeProvider.hasOwnProperty('__filemeta')) {
  Object.defineProperty(MDXScopeProvider, '__filemeta', {
    configurable: true,
    value: {
      name: "MDXScopeProvider",
      filename: "../../node_modules/gatsby-plugin-mdx/context.js"
    }
  });
}